import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { Patterns } from 'src/app/helpers/patterns';
import Swal from 'sweetalert2';
import { Record } from '../../../models/List.MenuCategories';
import { MenuCategoryService } from '../../../services/MenuCategories.service';

export interface DialogData {
  record: Record,
  restaurantId: number
}
@Component({
  selector: 'app-menu-categories-form',
  templateUrl: './menu-categories-form.component.html'
})
export class MenuCategoriesFormComponent extends DirtyComponent implements OnInit {

  override formGroup!: FormGroup;
  dataLoading = false;
  loading = false;
  isSubmitted = false;

  isUpdate: boolean = this.data.record ? true : false;

  constructor(
    override dialogRef: MatDialogRef<MenuCategoriesFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private service: MenuCategoryService,
    translate: TranslateService
  ) {
    super(translate)
  }

  ngOnInit(): void {
    this.buildForm();
    if (this.isUpdate) {
      this.bindDataToUpdate();
    }
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      title_EN: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(20),
        // Validators.pattern(Patterns.enTxt)
      ]],
      title_AR: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(20),
        // Validators.pattern(Patterns.arTxt)
      ]],
      restaurantId: [this.data.restaurantId]
    });
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
  override canDeactivate(): boolean {
    return this.formGroup.dirty;
  };
  bindDataToUpdate() {
    this.formGroup.patchValue({
      title_EN: this.data.record.title_EN,
      title_AR: this.data.record.title_AR,
      restaurantId: this.data.restaurantId
    });
  }

  saveRecord(openNew: boolean = false) {
    this.isSubmitted = true;
    if (this.formGroup.valid) {
      this.loading = true;
      let data = {
        id: '',
        title_EN: this.formGroup.controls['title_EN'].value,
        title_AR: this.formGroup.controls['title_AR'].value,
        restaurantId: this.data.restaurantId
      };

      let msg = this.translate.instant('swalMsg.savedsuccessfully');
      if (this.isUpdate) {
        data.id = this.data.record.id;
        msg = this.translate.instant('swalMsg.updatedsuccessfully');
      }
      this.service.saveRecord(data).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: msg,
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        if (openNew) {
          this.formGroup.reset();
          this.service.refreshList.next(true);
        } else {
          this.dialogRef.close(true);
        }
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }
}
